import { useState } from 'react';
import EmbeddedKendoReportData from './EmbeddedKendoReportData';


const useEmbeddedKendoReportData = () => {
  const [reportState, setReportState] = useState({ ...EmbeddedKendoReportData.INITIAL_STATE });

  const getKendoReportData = (reportId, reportParameters) => {
    return EmbeddedKendoReportData.runKendoReport(reportId, reportParameters, reportState, setReportState);
  };

  const getKendoReportTitle  = (reportId, reportParameters) => {
    return EmbeddedKendoReportData.getDynamicReportTitle(reportId, reportParameters, reportState, setReportState);
  };

  return {
    reportState,
    getKendoReportData,
    getKendoReportTitle
  };
};

export default useEmbeddedKendoReportData;